import {queryParams} from './services/query-params';

const delNul = (params = {}) => {
    const result = {};
    Object
        .keys(params)
        .forEach(key => {
            const val = params[key];
            if (
                typeof val === 'undefined' ||
                val === null
            ) return false;

            result[key] = val;
            return true;
        });

    return result;
};

const messyParams = delNul({
    authorId: queryParams.studentId,
    bundleId: queryParams.bundleId,
    category: queryParams.projectType,
    classId: queryParams.class,
    lessonId: queryParams.lesson,
    original_id: queryParams.templateId,
    target: queryParams.target
});

export {
    messyParams,
    delNul
};
